import {AxiosError} from "axios";

export function apiErrorMessage(e: any): string | undefined {
    if (e instanceof AxiosError) {
        return (e.response && e.response.data && (e.response.data as { error?: string }).error) || e.message;
    } else if (e instanceof Error) {
        return e.message;
    } else {
        return undefined;
    }
}